import { Locale } from 'vue-i18n'

export * from './config_urls'

export const APP_NAME = 'UP Browser Extension'

export const RELAY_SERVICE_NAME = 'Transaction Relay Service'

export const INPAGE_STREAM = 'inpage'
export const CONTENT_PAGE_STREAM = 'contentpage'
export const INPAGE_CHANNEL = 'provider'
export const CONTROLLER = 'controller'
export const LOCAL_CHANNEL = 'local-provider'

export const DEFAULT_IDLE_TIMEOUT_IN_MINUTES = 10
export const MAX_IDLE_TIMEOUT_IN_MINUTES = 60
export const IDLE_TIMEOUT = 'idleTimeout'

export const TOOLTIP_OPEN_DELAY = 300
export const TOOLTIP_CLOSE_DELAY = 1000
export const EDIT_THRESHOLD_IN_MINUTES = 60

export const PORT_SENDER_CONTENT_PAGE = 'contentpage'

export const NOTIFICATION_LISTENER = 'notification'
export const LSP3_PROFILE = 'LSP3Profile'
export const LSP4_METADATA = 'LSP4Metadata'
export const LSP4_TOKEN_NAME = 'LSP4TokenName'
export const LSP4_TOKEN_SYMBOL = 'LSP4TokenSymbol'
export const LSP8_TOKEN_ID_TYPE = 'LSP8TokenIdType'

export const AVAILABLE_LOCALES: Locale[] = ['en-US', 'en-GB'] // TODO: add 'de-DE', 'pl-PL' locales when they are populated
export const FALLBACK_LOCALE: Locale = 'en-US'

export const EXTENSION_ORIGIN = 'UP-Browser-Extension'
// Chain ID to token symbol
export const NATIVE_TOKEN_SYMBOLS = new Map<number, string>([
  [42, 'LYX'],
  [4201, 'LYXt'],
  [1, 'ETH'],
  [11_155_111, 'SETH'],
  [8453, 'ETH'],
  [84_532, 'SETH'],
])
export const DEFAULT_NATIVE_TOKEN_SYMBOL = 'LYX'

export enum Operations {
  OPERATION_CALL = 0,
  CREATE = 1,
  CREATE2 = 2,
  STATIC_CALL = 3,
  DELEGATE_CALL = 4,
}

export const ETH_GAS_DEFAULTS = {
  GAS_PRICE_IN_GWEI: '3',
  MAX_PRIORITY_FEE_PER_GAS_IN_GWEI: '3',
}

export const PAST_EVENTS_ETH_FETCH_COUNT = 1000

export const SETTINGS_DB_NAME = 'UPSettings'

const ROOT_URL = 'https://my.universalprofile.cloud'

export const UNIVERSAL_CLOUD_URL = 'https://universalprofile.cloud'

export const UNIVERSAL_EVERYTHING_URL = 'https://universaleverything.io'

export const RECOVER_WITH_3RD_PARTY =
  'https://my.universalprofile.cloud/3rd-party'

export enum MY_UNIVERSAL_PROFILE_DAPP {
  CREATE_PROFILE_PAGE = ROOT_URL + '/create',
  RECOVERY_PROFILE_PAGE = ROOT_URL + '/recover/auth',
  AFTER_INSTALL_PAGE = ROOT_URL + '/after-install',
}

export const TRANSAK_API_KEY = '9a203d41-0d94-445c-9bd6-a41341691864'
export const TRANSAK_PRODUCTION_API_URL = 'https://global.transak.com'

export const RAMP_PRODUCTION_API_URL = 'https://app.ramp.network'
export const RAMP_PRODUCTION_API_KEY =
  'q4dm79j3v4p4kpwyzxg8y93n4vf2jwmcptu7ekqz'
export const FAUCET_URLS = {
  mainnet: undefined,
  'ethereum-mainnet': undefined,
  'base-mainnet': undefined,
  'ethereum-sepolia': 'https://www.alchemy.com/faucets/ethereum-sepolia',
  'base-sepolia': 'https://www.alchemy.com/faucets/base-sepolia',
  testnet: 'https://faucet.testnet.lukso.network',
}

export const LSP26_FOLLOWER_SYSTEM_CONTRACT_ADDRESS_MAINNET =
  '0xf01103E5a9909Fc0DBe8166dA7085e0285daDDcA'
export const LSP26_FOLLOWER_SYSTEM_CONTRACT_ADDRESS_TESTNET =
  '0xcc439C9f4A3ebA8fb69945e650BbAB717741Fe99'
